export default ['bedc:notification:create/test', 'bedc:notification:create/announcement'] as const;
